// index.js

import { createI18n } from 'vue-i18n'
// 引入element-plus多语言
import elementEN from 'element-plus/es/locale/lang/en'
import elementZH from 'element-plus/es/locale/lang/zh-cn'
import elementZHTW from 'element-plus/es/locale/lang/zh-tw'
// 引入各个模块的语言包
import enLocale from './en'
import zhLocale from './zh'
import zhTWLocale from './zhtw'

import { getCookie, setCookie } from '../utils/cookei'

const messages = {
    English: {
        ...elementEN,
        ...enLocale
    },
    Chinese: {
        ...elementZH,
        ...zhLocale
    },
    'zh-TW': {
        ...elementZHTW,
        ...zhTWLocale
    },
}

export const getLocale = () => {
    // 获取缓存
    const storLanguage = getCookie('language')
    // 存在返回当前语言
    const language = navigator.language;
    console.log('language', language, storLanguage)
    if (storLanguage) {
        return storLanguage
    }else {
        let lang = ''
        if (language === 'zh-CN') {
            lang = 'Chinese'
        } else if (language === 'zh-TW') {
            lang = 'zh-TW'
        } else if (language === 'en-US' || language == 'en') {
            lang = 'English'
        } else{
            lang = 'English'
        }
        setCookie('language', lang, true)
        // 默认返回简体中文
        return lang
    }   
}
const i18n = createI18n({
  globalInjection: true,
  legacy: false,
  locale: getLocale(),
  messages: messages
})
export default i18n

